import {useEffect , useState} from 'react'
import util from "../../utils/utils";
import axios from 'axios';
import { useNavigate ,useLocation, useSearchParams} from 'react-router-dom';
import { Mail,ChevronLeft,ChevronsUp,Download, Share2,Activity,Clock} from 'react-feather';
import useGetFullPolicy from '../Policy/hooks/useGetFullPolicy';
import useGetPolicyTimelineMindmap from '../Policy/hooks/useGetPolicyTimelineMindmap';
import {LoadingDiv } from '@components/LoadingDiv';
import { Markdown2Svg } from '@components/Markdown2Svg';
import {FullScreenMindTreeModal} from '@components/FullScreenMindTreeModal'
import {MarkBtn} from './components/MarkBtn';
import useGetSavedFoldList from '../../hooks/useGetSavedFoldList';
import useGetPdf from '@hooks/useGetPdf'
import {MarkModal} from '../../components/MarkModal'
import {PdfViewer} from '@components/PdfViewer'
import {WordViewer} from '@components/WordViewer'
import {ExcelViewer} from '@components/ExcelViewer'
import { ScrolltoTopBtn } from '@components/ScrolltoTopBtn';
import {Timeline} from './components/Timeline'
import { ErrorBoundary } from '@components/ErrorBoundary/index';
export const PolicyFilePage = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { pathname } = useLocation();
  const [fileName, setFileName] = useState('')
  const [mdTxt,setMdTxt] =useState('')
  const {savedFoldListLoading, savedFoldListData, savedFoldListRefresh} = useGetSavedFoldList()
  const {getPdfLoading,getPdfAction} = useGetPdf()
  const [markData, setMarkData] = useState()

  useEffect(()=>{
    setFileName(searchParams.get('fileName'))
  },[])

// Add this new useEffect for dynamic title
useEffect(() => {
    if (fileName) {
      document.title = `${fileName} - ${process.env.REACT_APP_NAME}`;
    } else {
      document.title = process.env.REACT_APP_NAME;
    }
    
    // Cleanup function to reset title when component unmounts
    return () => {
      document.title = process.env.REACT_APP_NAME;
    };
  }, [fileName]);

//   const [upBtnVisible,setUpBtnVisible] = useState(false)
  const {getFullPolicyAction ,fullPolicyLoading} = useGetFullPolicy();
  const {getPolicyTimelineMindmapAction, policyTimelineMindmapLoading} = useGetPolicyTimelineMindmap();
  const [data,setData] =useState()
  const [viewPolicy, setViewPolicy] = useState()
  const [index,setIndex] = useState(0)

  useEffect(()=>{
    if(fileName){
        viewFullPolicyAction(fileName)
    }
},[fileName])

// 添加监听在线链接点击事件的useEffect
useEffect(() => {
    const handleLinkClick = (event) => {
        // 检查点击的是否是<a>标签
        if (event.target.tagName === 'A' || event.target.closest('a')) {
            const linkElement = event.target.tagName === 'A' ? event.target : event.target.closest('a');
            const href = linkElement.getAttribute('href');
            
            // 判断是否是外部链接（以http开头）
            if (href && (href.startsWith('http://') || href.startsWith('https://'))) {
                // 阻止默认的链接跳转行为
                event.preventDefault();
                event.stopPropagation();
                
                // 获取链接文字内容
                const linkText = linkElement.textContent || linkElement.innerText;
                
                // 这里可以添加你的处理逻辑，比如转换为本地资源链接
                // handleExternalLinkClick(href, linkText);
                
                // 示例：不同的处理方式
                handleLinkAction(href, linkText);
            }
        }
    };

    // 处理链接点击的不同方式
    const handleLinkAction = (href, linkText) => {
        let _href = href

        if(process.env.REACT_APP_TYPE === 'grid-build' ){
            const fileExtension = href.split('.').pop().toLowerCase();
            // 清理linkText，去除首尾空格
            const cleanLinkText = linkText.trim();

            // 更严格的检查，避免重复后缀
            let fileName = cleanLinkText;
            const lowerLinkText = cleanLinkText.toLowerCase();

            // 只有当linkText不以该扩展名结尾时才添加
            if (!lowerLinkText.endsWith(`.${fileExtension}`)) {
                fileName = `${cleanLinkText}.${fileExtension}`;
            }

            // 对fileName进行URL编码，避免空格等特殊字符导致的路由错误
            const encodedFileName = encodeURIComponent(fileName);
            _href = `${process.env.REACT_APP_DOMAIN_API}/attach/download/${searchParams.get('fileId')}_${encodedFileName}`
        }
        handleByFileType(_href, linkText);
    };

    // 强制下载方法
    const forceDownload = async (url, filename) => {
        try {
            console.log('开始强制下载:', filename);

            // 使用fetch获取文件
            const response = await fetch(url, {
                mode: 'cors', // 需要服务器支持CORS
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            // 创建blob对象
            const blob = await response.blob();

            // 创建下载链接
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = downloadUrl;
            a.download = filename || '下载文件';
            document.body.appendChild(a);
            a.click();

            // 清理
            document.body.removeChild(a);
            window.URL.revokeObjectURL(downloadUrl);

        } catch (error) {
            console.error('下载失败:', error);
            // 显示附件地址提示
            alert(`附件不存在或无法访问\n文件名：${filename}\n附件地址：${url}\n\n请手动访问`);
        }
    };

    // 检查文件并可处理错误
    const checkAndOpenFile = (url, filename) => {
        // 尝试在新窗口打开文件
        const newWindow = window.open(url, '_blank');

        // 检查窗口是否成功打开（某些浏览器可能阻止弹窗）
        if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
            alert(`无法打开文件，可能是浏览器阻止了弹窗\n文件名：${filename}\n附件地址：${url}\n\n请手动访问链接`);
            return;
        }

        // 添加错误检测 - 监听新窗口的错误事件
        try {
            newWindow.addEventListener('error', () => {
                setTimeout(() => {
                    alert(`附件不存在或无法访问\n文件名：${filename}\n附件地址：${url}\n\n请手动访问`);
                }, 1000);
            }, true);
        } catch (e) {
            // 跨域限制，无法监听其他域的错误，降级处理
            console.log('无法监听跨域窗口错误，这是正常的');
        }
    };

    // 根据文件类型决定处理方式
    const handleByFileType = (href, linkText) => {
        const fileExtension = href.split('.').pop().toLowerCase();

        console.log('文件扩展名:', fileExtension);

        switch (fileExtension) {
            case 'pdf':
                // PDF文件：在新标签页打开预览
                console.log('PDF文件，在新标签页打开');
                checkAndOpenFile(href, linkText);
                break;

            case 'doc':
            case 'docx':
            case 'xls':
            case 'xlsx':
            case 'ppt':
            case 'pptx':
                // Office文件：强制下载
                console.log('Office文件，强制下载');
                forceDownload(href, linkText);
                break;

            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'gif':
                // 图片文件：在新标签页打开
                console.log('图片文件，在新标签页打开');
                checkAndOpenFile(href, linkText);
                break;

            default:
                // 其他文件：提示用户选择
                console.log('未知文件类型，提示用户选择');
                showActionModal(href, linkText);
                break;
        }
    };

    // 显示操作选择模态框
    const showActionModal = (href, linkText) => {
        const userChoice = window.confirm(
            `文件: ${linkText}\n\n点击"确定"下载文件\n点击"取消"在新窗口打开`
        );

        if (userChoice) {
            forceDownload(href, linkText);
        } else {
            checkAndOpenFile(href, linkText);
        }
    };

    // 获取政策内容容器
    const policyContentContainer = document.getElementById('policyFileContent');
    
    if (policyContentContainer) {
        // 添加事件监听
        policyContentContainer.addEventListener('click', handleLinkClick);
        
        // 清理函数，组件卸载时移除事件监听
        return () => {
            policyContentContainer.removeEventListener('click', handleLinkClick);
        };
    }
}, [data]); // 依赖data，确保在内容渲染后添加监听

const viewFullPolicyAction = (item) => {
    reset();
    setFileName(item)
    getFullPolicyAction({policy_title:item,search_content:searchParams.get('searchContent') ?? '',policy_id: searchParams.get('fileId')})
    .then(res=>{
        setData(res)
        getPolicyTimelineMindmapAction({policy_title:item, policy_id:searchParams.get("fileId")})
        .then(res=>{setViewPolicy(res);setMdTxt(res?.policy_mind_map?.replace(/\>+/g, '-') ?? '')})
    });


}

// useEffect(()=>{
//     document.getElementById('policyFileContent')?.addEventListener('click', function(event) {
//         if(event.target.tagName === 'A') {
//             reset();
//             viewFullPolicyAction(event.target.id?.replace(/《|》/g, ""))
//         }
//       });
// },[])

// useEffect(()=>{
//     window.addEventListener("scroll",e=>{
//         util?.throttle(setUpBtnStatus(),1000)
//     })
// },[])
// const setUpBtnStatus = () => {
//     let scrollTop = document.documentElement.scrollTop
//     // console.log(scrollTop)
//     if(scrollTop > 800){
//         setUpBtnVisible(true)
//     }else{
//         setUpBtnVisible(false)
//     }
// }
const reset = () => {
  setIndex(0);
  document.documentElement.scrollTop = 0
//   document.getElementById('shareTopAnchor').scrollIntoView()
}

const [copied, setCopied] = useState(false)
useEffect(()=>{
    if(copied){
        setTimeout(()=>{
            setCopied(false)
        },2000)
    }
},[copied])
const share = () => {
    const txt = `${process.env.REACT_APP_DOMAIN}policy/file?fileName=${fileName}&fileId=${searchParams.get('fileId')}&searchContent=${searchParams.get('searchContent') ?? ''}`
    util.copyTxt(txt)
    setCopied(true);
}
const pageBack = () => {
    const returnUrl = searchParams.get('returnUrl')
    if(returnUrl){
        try {
            // 检查returnUrl是否是有效的URL
            const decodedReturnUrl = decodeURIComponent(returnUrl);
            const returnUrlObj = new URL(decodedReturnUrl);
            
            // 检查是否是同一个域名的不同端口
            const currentHost = window.location.hostname;
            const returnHost = returnUrlObj.hostname;
            
            // 如果是同一个域名但不同端口，检查localStorage是否存在
            if (currentHost === returnHost) {
                const userInfo = util.getStorage(process.env.REACT_APP_LOCALSTORAGE_NAME);
                if (!userInfo || !userInfo.id) {
                    console.warn('用户信息不存在，重新登录');
                    // 清除可能损坏的localStorage
                    util.removeStorage(process.env.REACT_APP_LOCALSTORAGE_NAME);
                    // 跳转到登录页而不是外部系统
                    window.location.href = `${process.env.REACT_APP_DOMAIN}login`;
                    return;
                }
            }
            
            // 检查是否是外部系统（不同域名或端口）
            if (returnUrlObj.port && returnUrlObj.port !== window.location.port) {
                console.warn('检测到跨系统跳转，请确认用户信息');
                // 可以在这里添加额外的验证逻辑
            }
            
            window.location.href = decodedReturnUrl;
        } catch (error) {
            console.error('returnUrl解析失败:', error);
            // 降级处理：跳转到政策首页
            window.location.href = `${process.env.REACT_APP_DOMAIN}policy`;
        }
    }else{
        window.location.href = `${process.env.REACT_APP_DOMAIN}policy`
    }
}

const scrollIntoHightLight = (type) => {
    let containerElement = document.getElementById('policyFileContent')
    let childElements = containerElement.getElementsByClassName('bg-yellow-200');
    childElements[index]?.scrollIntoView({behavior: "smooth",block: "center", inline: "nearest"});
    if(type === 'forward'){
        setIndex((index + 1) % data?.high_light.length)
    }else if(type === 'back'){
        setIndex((index - 1) % data?.high_light.length)
    }
}

  
    return (
      <div class="md:px-6 lg:px-12 2xl:px-16 3xl:px-24 bg-base-200 w-full flex flex-col h-full "   id="fileContentScrollDiv ">
            <MarkModal
                markData={markData}
                loading={savedFoldListLoading}
                data={savedFoldListData}
                savedFoldListRefresh={savedFoldListRefresh}
            />

        <FullScreenMindTreeModal
            fileName={fileName}
            txt={mdTxt}
            setFileName={setFileName}
            setMdTxt={()=>setMdTxt(viewPolicy?.policy_mind_map?.replace(/\>+/g, '-') ?? '')}

        />

        {/* {upBtnVisible && <div id="back-to-top" className="fixed bottom-8 right-12 lg:right-[35vw] z-20">
            <button className="btn btn-circle btn-outline bg-base-100" 
                onClick={()=>window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                })}
            >
                <ChevronsUp size="16"/>
            </button>
        </div>} */}
        <div className="fixed bottom-8 right-12 lg:right-[35vw] z-20">
            <ScrolltoTopBtn/>
        </div>
        <div className='m-3 bg-base-100 flex-1 max-w-[2360px] w-full mx-auto shadow-lg'>
            <div className="p-0 realtive w-full h-full">
                {/* <div id="shareTopAnchor"></div> */}

                {/* <div className="bg-white p-4">
                    <div className={`flex space-between items-center`}>
                        {searchParams.get('searchContent') ? <div className='flex flex-1'>

                            <h2 className="card-title pl-4">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth='1.5' stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" />
                                </svg>
                                检索关联：{data?.high_light?.length}处
                            </h2>
                            <button className='ml-6' style={{transform: 'scaleX(-1)'}} disabled={index===0} onClick={()=>{scrollIntoHightLight('back')}}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6" style={{opacity:index === 0 ? 0.3 : 1}}>
                                    <path fillRule="evenodd" d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z" clipRule="evenodd" />
                                </svg>
                            </button>
                            <button className='mx-1' disabled={data?.high_light?.length ===0 } onClick={()=>{scrollIntoHightLight('forward')}}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6" style={{opacity:data?.high_light?.length ===0 ? 0.3 : 1}}>
                                    <path fillRule="evenodd" d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z" clipRule="evenodd" />
                                </svg>
                            </button>
                        </div> :
                        <h2 className="card-title pl-4 mr-6 flex-1">{fileName}</h2>
                        }
                    </div>
                </div> */}

                <div className=" p-2 lg:px-8 lg:py-2 text-justify lg:flex lg:gap-6">
                    <div  className='lg:w-2/3'>
                        <div className="flex justify-between items-center p-4 pt-4 bg-base-100 z-10 sticky top-0">
                            <div className='flex'>
                                {/* <span className='hover:primary cursor-pointer' onClick={()=>pageBack()}>返回</span> */}
                                <div className="divider divider-horizontal"></div>
                                {searchParams.get('searchContent') && <div className='flex flex-1'>
                                    <h2 className="pl-4">
                                        检索关联：{data?.html_high_light?.length}处
                                    </h2>
                                    <button className='ml-6' style={{transform: 'scaleX(-1)'}} disabled={index===0} onClick={()=>{scrollIntoHightLight('back')}}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6" style={{opacity:index === 0 ? 0.3 : 1}}>
                                            <path fillRule="evenodd" d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z" clipRule="evenodd" />
                                        </svg>
                                    </button>
                                    <button className='mx-1' disabled={data?.high_light?.length ===0 } onClick={()=>{scrollIntoHightLight('forward')}}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6" style={{opacity:data?.high_light?.length ===0 ? 0.3 : 1}}>
                                            <path fillRule="evenodd" d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z" clipRule="evenodd" />
                                        </svg>
                                    </button>
                                </div>}
                            </div>
                            <div className='flex items-center gap-1'>
                                {
                                    process.env.REACT_APP_TYPE !== 'grid-build' && <>
                                        {
                                            copied ? 
                                            <button className="btn btn-sm ml-4 btn-disabled">
                                            ✔️ 已复制
                                            </button>
                                            :
                                            <button className="btn btn-ghost btn-sm btn-secondary ml-4" onClick={()=>{share()}}>
                                                <Share2 size="15"/>
                                                分享
                                            </button>
                                        }
                                    </>
                                }
                                <MarkBtn
                                    savedFoldListData={savedFoldListData}
                                    source_id={data?.policy_id}
                                    setMarkData={setMarkData}
                                    
                                />
                                <button className="btn btn-ghost btn-sm btn-ghost btn-secondary" 
                                onClick={()=>getPdfAction({policy_info:[{policy_title:fileName,policy_id:data?.policy_id}]})}
                                >
                                    <Download size="15"/>下载
                                </button>
                            </div>

                        </div>
                        <div className='p-6'>
                            {
                                fullPolicyLoading || !data ? 
                                <>
                                <LoadingDiv/>
                                </> :
                                <>
                                    {searchParams.get('searchContent') && data?.high_light?.length > 0 && (
                                      <div className="bg-base-200 mx-12 p-6 rounded-lg mb-12">
                                        <div className="flex items-center gap-2 mb-4">
                                          <span className="font-bold text-gray-500">检索内容：</span>
                                          <span className="">{searchParams.get('searchContent')}</span>
                                        </div>
                                        
                                        <div className="flex flex-col gap-2">
                                          <div className="flex items-start gap-2">
                                            <span className="font-bold text-gray-500 whitespace-nowrap mt-1">关联内容：</span>
                                            <div className="flex-1" 
                                              dangerouslySetInnerHTML={{ 
                                                __html: util.HighlightText(
                                                  data?.full_policy?.substring(
                                                    Math.max(0, data?.high_light?.[0]?.start_position - 50),
                                                    Math.min(data?.full_policy?.length, data?.high_light?.[0]?.end_position + 50)
                                                  ),
                                                  [{
                                                    start_position: 50,
                                                    end_position: 50 + (data?.high_light?.[0]?.end_position - data?.high_light?.[0]?.start_position)
                                                  }]
                                                )
                                              }}
                                            />
                                          </div>
                                          {data?.high_light?.length > 1 && <div className="text-right text-gray-500">
                                            等 {data?.high_light?.length} 处
                                          </div>}
                                        </div>
                                      </div>
                                    )}
                                    <div className="bg-white">
                                        <h2 className="text-3xl font-bold text-center m-6 p-12 pt-6 border-b-2 border-solid border-[#D62828]">{fileName}</h2>
                                        <div className='flex flex-wrap justify-center mb-12'>
                                            <span className='font-bold text-gray-500'>政策类型：</span>
                                            {data?.large_policy_class}
                                            <div className="divider divider-horizontal"></div>
                                            <span className='font-bold text-gray-500'>政策来源：</span>
                                            {data?.from_organization}
                                            <div className="divider divider-horizontal"></div>
                                            <span className='font-bold text-gray-500'>发布时间：</span>
                                            {data?.policy_time?.slice(0,10)}
                                        </div>
                                    </div>
                                </>
                            }

                        </div>
                        <div id='policyFileContent' className='p-6'>
                            {
                                fullPolicyLoading || !data ? 
                                <>
                                <LoadingDiv/>
                                </> :
                                <>
                                        <div className="policyContentDiv overflow-x-auto"
                                            dangerouslySetInnerHTML={{ __html:  data?.html_content ? util.HighlightText(data?.html_content, data?.html_high_light) : util.HighlightText(data?.full_policy, data?.high_light) }}
                                        />
                                        {/* <div dangerouslySetInnerHTML={{ __html: data?.high_light ? 
                                        util.HighlightText(data?.full_policy ?? data?.txt_full_content, data?.high_light)
                                        : data?.full_policy ?? data?.txt_full_content }}>
                                        </div> */}


                                        {
                                            process.env.REACT_APP_TYPE !== 'grid-build' &&
                                            (util.extractPDFLinks(data?.html_content)?.length > 0 
                                            || util.extractExcelLinks(data?.html_content)?.length > 0
                                            || util.extractWordLinks(data?.html_content)?.length > 0
                                            ) &&
                                            <>
                                            <h2 className="text-2xl font-bold p-8 pb-2">附件导览：</h2>
                                            <h3 className="text-md font-bold p-8 pt-2 pb-6">（若导览无法查看，请点击上方链接跳转）</h3>
                                            {

                                                util.extractPDFLinks(data?.html_content)?.map(pdfFile => {
                                                    // console.log(pdfFile)
                                                    return (
                                                        <PdfViewer
                                                            file={pdfFile}
                                                        />
                                                    )
                                                })
                                            }
                                            {
                                                util.extractWordLinks(data?.html_content)?.map(wordFile => {
                                                    // console.log(wordFile)
                                                    return (
                                                        <WordViewer
                                                            file={wordFile}
                                                        />
                                                    )
                                                })
                                            }

                                            {
                                                util.extractExcelLinks(data?.html_content)?.map(excelFile => {
                                                    // console.log(excelFile)
                                                    return (
                                                        <ExcelViewer
                                                            file={excelFile}
                                                        />  
                                                    )
                                                })
                                            }
                                            </>
                                        }
                                </>
                            }
                        </div>

                    </div>
                    <div className='lg:w-1/3 h-full sticky top-0 max-h-screen'>
                        <div className='border my-6'>
                            <h2 className="card-title bg-primary text-white p-4 px-6 border-b">
                                <Activity color='white' size='1.4rem'/>
                                {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="m21 7.5-2.25-1.313M21 7.5v2.25m0-2.25-2.25 1.313M3 7.5l2.25-1.313M3 7.5l2.25 1.313M3 7.5v2.25m9 3 2.25-1.313M12 12.75l-2.25-1.313M12 12.75V15m0 6.75 2.25-1.313M12 21.75V19.5m0 2.25-2.25-1.313m0-16.875L12 2.25l2.25 1.313M21 14.25v2.25l-2.25 1.313m-13.5 0L3 16.5v-2.25" />
                                </svg> */}
                               文章脉络 :
                            </h2>
                            <div className='relative p-4'>
                                {
                                    policyTimelineMindmapLoading || !viewPolicy ? 
                                    <>
                                    <LoadingDiv/>
                                    </> :
                                    <ErrorBoundary>
                                        <Markdown2Svg
                                        fileName={fileName}
                                        setFileName={setFileName}
                                        setMdTxt={()=>setMdTxt(viewPolicy?.policy_mind_map?.replace(/\>+/g, '-') ?? '')}
                                        divHeight='middle'
                                        txt={mdTxt}
                                        />
                                    </ErrorBoundary>
                                }
                            </div>
                        </div>
                        <div className="border mb-6 flex flex-col">
                            <h2 className="card-title bg-primary text-white p-4 px-6 border-b">
                                <Clock color='white' size='1.4rem'/>
                                {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                </svg> */}
                               政策时间线分析 :
                            </h2>
                            <div className='max-h-[42vh] overflow-auto'>
                                <Timeline
                                    filePageData={data}
                                    currentPolicy={{
                                        policy_title: fileName,
                                        source_id: searchParams.get('fileId'),
                                        // policy_time: searchParams.get('policyTime'),
                                        // from_organization: searchParams.get('fromOrganization')
                                    }}
                                    mode='small'
                                />
                            </div>

                            {/* {
                                policyTimelineMindmapLoading || !viewPolicy ? 
                                <div className='p-4'>
                                    <LoadingDiv/>
                                </div> :
                                <>
                                {
                                    viewPolicy?.time_line && 
                                    <ul className={`overflow-auto flex-1 max-h-[40vh] timeline timeline-snap-icon max-md:timeline-compact timeline-vertical  p-4 my-timeline`}>
                                    {viewPolicy?.time_line?.map(item =>
                                        <li>
                                            <div className="timeline-middle">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="h-5 w-5">
                                                <path fillRule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm.75-11.25a.75.75 0 0 0-1.5 0v4.59L7.3 9.24a.75.75 0 0 0-1.1 1.02l3.25 3.5a.75.75 0 0 0 1.1 0l3.25-3.5a.75.75 0 1 0-1.1-1.02l-1.95 2.1V6.75Z" clipRule="evenodd" />
                                                </svg>
                                            </div>
                                            <div className="timeline-end mb-10">
                                                <time className="font-mono italic">{item?.policy_time?.split(' ')[0] ?? item?.policy_time}  {item?.from_organization}</time>
                                                <div className="text-lg font-black link hover:text-primary" onClick={()=>{viewFullPolicyAction(item?.policy_title)}}>{item?.policy_title}</div>
                                            </div>
                                            <hr/>
                                        </li>
                                    )}
                                    </ul>
                                }
                                </>
                            } */}
                        </div>

                    </div>
                </div>
            </div>

        </div>
      </div>

    )
}